import HttpService from "./HttpService";

let habilidadeService = {

    buscarListaDeHabilidades: (idCaderno) => {
        return HttpService.backApi.get('/habilidades/list?idCaderno=' + idCaderno);
    },

    buscarHabilidade: (id) => {
        return HttpService.backApi.get(`/habilidades/${id}`)
    },

    salvarhabilidade: (habilidade) => {
        return HttpService.backApi.post("/habilidades/create", habilidade)
    },

    atualizarHabilidade: (habilidade) => {
        return HttpService.backApi.put("/habilidades", habilidade)
    },

    deletarHabilidade: (id) => {
        return HttpService.backApi.delete(`/habilidades/${id}`)
    }

};

export default habilidadeService;
